import type { ComponentType } from "react";

import type { MediaIconType } from "../../common/index.ts";
import type { SkiliticsIconName } from "../../icons/index.ts";
import {
  FieldImageAsset,
  FieldMediaAsset,
  FieldVideoAsset,
  type MediaAssetType,
  type UploadOptions,
  audioAssetUploadOptions,
  imageAssetUploadOptions,
  modelAssetUploadOptions,
  videoAssetUploadOptions,
} from "../controls/index.ts";

export const iconByMediaAssetType: Record<MediaAssetType, SkiliticsIconName> = {
  audio: "layer-audio",
  image: "layer-image",
  video: "layer-video",
  model: "layer-3d",
};

export const mediaIconByMediaAssetType: Record<MediaAssetType, MediaIconType> = {
  audio: "AudioMusic",
  image: "ImageRaster",
  video: "Video",
  model: "VrActivity",
};

export const uploadOptionsByMediaAssetType: Record<MediaAssetType, UploadOptions> = {
  audio: audioAssetUploadOptions,
  image: imageAssetUploadOptions,
  video: videoAssetUploadOptions,
  model: modelAssetUploadOptions,
};

export const componentTypeByMediaAssetType: Record<MediaAssetType, ComponentType<any>> = {
  audio: FieldMediaAsset,
  image: FieldImageAsset,
  video: FieldVideoAsset,
  model: FieldMediaAsset,
};

export const MB = 1024 * 1024;

export const maximumFilesizeByMediaAssetType: Record<MediaAssetType, number> = {
  audio: 250 * MB,
  image: 25 * MB,
  video: 250 * MB,
  model: 250 * MB,
};
